// StudioInvitationAcceptance.js - PRODUCTION VERSION
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';
import {
  CheckCircle,
  Business,
} from '@mui/icons-material';
import { UseApi } from '../Hooks/UseApi';

const StudioInvitationAcceptance = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const api = UseApi();
  
  const [loading, setLoading] = useState(false);
  const [invitationData, setInvitationData] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Debug logging
  useEffect(() => {
  }, [token, api]);

  const handleAcceptInvitation = async () => {
    try {
      setLoading(true);
      setError(null);
      // Use the dedicated UseApi method instead of fetchWithAuth directly
      const response = await api.completeStudioInvitation(token);
      setSuccess(true);
      setInvitationData(response);
      
      // Redirect to dashboard after 3 seconds
      setTimeout(() => {
        navigate('/dashboard');
      }, 3000);
      
    } catch (error) {
      console.error('❌ Error accepting invitation:', error);
      setError(error.message || 'Failed to accept invitation');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Container maxWidth="md" sx={{ mt: 8 }}>
        <Card>
          <CardContent sx={{ textAlign: 'center', py: 6 }}>
            <CheckCircle color="success" sx={{ fontSize: 80, mb: 3 }} />
            <Typography variant="h4" gutterBottom color="success.main">
              Welcome to the Team!
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              You've successfully joined {invitationData?.studio_name || 'the studio'}!
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Redirecting to dashboard in 3 seconds...
            </Typography>
          </CardContent>
        </Card>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      <Card>
        <CardContent sx={{ p: 6 }}>
          <Box textAlign="center" mb={4}>
            <Business color="primary" sx={{ fontSize: 60, mb: 2 }} />
            <Typography variant="h4" gutterBottom>
              Studio Invitation
            </Typography>
            <Typography variant="body1" color="text.secondary">
              You've been invited to join a tattoo studio on InkedUp Manager
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <Box textAlign="center">
            <Button
              variant="contained"
              size="large"
              onClick={handleAcceptInvitation}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <CheckCircle />}
              sx={{ minWidth: 200 }}
            >
              {loading ? 'Accepting...' : 'Accept Invitation'}
            </Button>
          </Box>

          <Box mt={4} textAlign="center">
            <Typography variant="body2" color="text.secondary">
              By accepting this invitation, you'll become a member of the studio and gain access to shared resources.
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default StudioInvitationAcceptance;